/** @format */

import { Box, Drawer } from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { updateSelectedDocument } from "../../../store/reducers/pdfeditor/pdfDetailsSlice";
import { updateAllCoordinates } from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { clearAllToolModificationData } from "../../../store/reducers/pdfeditor/toolsModificationSlice";
import { getDocumentsDetailsApi } from "../../../store/reducers/pdfeditor/getDocumentsDetailSlice";
import { pdfToolApi } from "../../../services/PdfEditor/pdfToolApi";
import { updatePageData } from "../../../store/reducers/pdfeditor/pageModificationSlice";
import { clearInsertPdf } from "../../../store/reducers/pdfeditor/insertPdfSlice";


const MainDrawer = ({ drawerData, open, setOpen }) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
    dispatch(updateSelectedDocument(null));
    dispatch(updateAllCoordinates(null));
    dispatch(clearAllToolModificationData());
    dispatch(updatePageData([]));
    dispatch(clearInsertPdf({}));
    pdfToolApi.refreshToken().then((res) => {
      dispatch(getDocumentsDetailsApi(res?.access));
    });
  };

  const stopPropagation = (event) => {
    event.stopPropagation();
  };
  return (
    <Wrapper>
      
      <Box
          sx={{ width: "100%" }}
          role='presentation'
          onClick={stopPropagation}
          onKeyDown={stopPropagation}
        >
          {drawerData}
        </Box>
      {/* <Drawer
        anchor={"right"}
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          handleClose();
        }}
        sx={{ width: "100%" }}
      >
        <Box
          sx={{ width: "100%" }}
          role='presentation'
          onClick={stopPropagation}
          onKeyDown={stopPropagation}
        >
          {drawerData}
        </Box>
      </Drawer> */}
    </Wrapper>
  );
};

export default MainDrawer;

const Wrapper = styled.div`
  .css-1160xiw-MuiPaper-root-MuiDrawer-paper {
    width: 100% !important;
  }
`;
